import type { ComponentProps, FC } from 'react';
import { SvgIcon } from './SvgIcon';

type Props = ComponentProps<typeof SvgIcon>;

const Icon: FC = () => {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_7772_24086)">
        <path
          d="M35.6 5.00994C35.28 3.42994 34.36 2.06994 33.02 1.18994C32 0.509941 30.84 0.189941 29.7 0.189941C27.74 0.189941 25.82 1.13994 24.67 2.88994C23.58 4.53994 23.38 6.56994 24.1 8.40994C23.8 9.07994 23.42 9.65994 22.94 10.1899C22.04 9.79994 21.09 9.60994 20.15 9.60994C17.87 9.60994 15.64 10.7199 14.31 12.7399L13.74 13.5999C13.44 14.0599 13.56 14.6799 14.02 14.9899L27.75 24.0799C27.92 24.1899 28.1 24.2399 28.29 24.2499C28.29 24.2499 28.29 24.2499 28.3 24.2499C28.62 24.2499 28.94 24.0899 29.13 23.7999L29.7 22.9399C31.59 20.0799 31.11 16.2999 28.67 13.9999C28.97 13.3499 29.36 12.7799 29.85 12.2399C31.82 12.1899 33.61 11.2099 34.71 9.55994C35.6 8.21994 35.91 6.60994 35.59 5.02994L35.6 5.00994ZM33.05 8.42994C32.31 9.54994 31.1 10.2199 29.72 10.2199C29.64 10.2199 29.56 10.2199 29.49 10.2199C29.47 10.2199 29.45 10.2199 29.44 10.2199C29.18 10.2199 28.93 10.3199 28.74 10.5099C27.73 11.4999 27.01 12.6299 26.53 13.9499C26.38 14.3599 26.53 14.8199 26.87 15.0799C28.97 16.6699 29.48 19.6299 28.03 21.8199L28.01 21.8499L15.95 13.8599L15.97 13.8299C16.93 12.3899 18.52 11.5999 20.14 11.5999C20.99 11.5999 21.85 11.8199 22.63 12.2699C22.79 12.3599 22.96 12.3999 23.13 12.3999C23.37 12.3999 23.62 12.3099 23.81 12.1399C24.84 11.1899 25.6 10.0899 26.12 8.75994C26.22 8.49994 26.21 8.20994 26.09 7.95994C25.46 6.65994 25.55 5.16994 26.34 3.98994C27.11 2.81994 28.4 2.18994 29.7 2.18994C30.46 2.18994 31.24 2.40994 31.92 2.85994C32.82 3.44994 33.43 4.35994 33.64 5.41994C33.85 6.46994 33.64 7.54994 33.05 8.44994V8.42994Z"
          fill="black"
        />
        <path
          d="M23.16 18.64L15.95 13.87L15.97 13.84C16.27 13.38 16.65 12.99 17.06 12.67C16.37 12.37 15.64 12.13 14.89 11.97C14.68 12.21 14.48 12.46 14.29 12.74L13.72 13.6C13.42 14.06 13.54 14.68 14 14.99L24.08 21.66C23.9 20.6 23.58 19.59 23.15 18.64H23.16Z"
          fill="black"
        />
        <path
          d="M18.42 20.05C18.38 20.15 18.34 20.24 18.27 20.33L12.63 28.15C12.46 28.39 12.23 28.58 11.97 28.72C11.71 28.85 11.42 28.92 11.13 28.92C10.84 28.92 10.54 28.85 10.28 28.71C10.02 28.58 9.80003 28.38 9.62003 28.14L6.28003 23.52C6.01003 23.14 5.98003 22.66 6.19003 22.25C6.40003 21.84 6.81003 21.59 7.27003 21.59H8.53003C9.13003 21.59 9.69003 21.88 10.04 22.36L11.13 23.88L14.53 19.17C14.86 18.71 15.39 18.43 15.95 18.41L13.03 16.48C11.74 15.63 11.39 13.89 12.24 12.6L12.81 11.74C12.81 11.74 12.83 11.71 12.84 11.7C12.65 11.7 12.47 11.67 12.28 11.67C5.65003 11.67 0.280029 17.04 0.280029 23.67C0.280029 30.3 5.65003 35.67 12.28 35.67C18.91 35.67 24.13 30.43 24.27 23.93L18.42 20.06V20.05Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_7772_24086">
          <rect width="36" height="36" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const WorkflowIcon: FC<Props> = (props) => {
  return <SvgIcon component={Icon} {...props} />;
};
